module.exports = "/_next/static/assets/img/legalonegmbh-54c89d762188ff27e93341d46135b24e.jpg";